import React from 'react';
import { updateCampaignsGroupsSuccess } from 'modules/campaigns/actions';
import { addIndication, INDICATION_TYPES } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { campaignGroupApi } from 'services/api';
import { errorMessagesUtils } from 'services/utils';

const successIndication = {
    message: (
        <FormattedMessage
            id="campaigns.group.bulk.save.success"
            defaultMessage="Campaigns groups successfully updated"
        />
    ),
    type: INDICATION_TYPES.SUCCESS,
    highlight: <FormattedMessage id="success.highlight" defaultMessage="Success!" />,
};

const generateErrorIndication = (errorObject = {}) => ({
    message: errorMessagesUtils.getErrorMessage(errorObject),
    type: INDICATION_TYPES.WARNING,
    highlight: <FormattedMessage id="creatives.save.error.highlight" defaultMessage="Unable to save changes." />,
});

const bulkUpdateCampaignsGroups =
    ({ accountId, campaignGroupIds, changes }) =>
    async dispatch => {
        const bulkUpdate = {
            campaignGroups: campaignGroupIds,
            update: changes,
        };
        try {
            const { results } = await campaignGroupApi.bulkUpdateCampaignsGroups(accountId, bulkUpdate);
            dispatch(addIndication(successIndication));
            dispatch(updateCampaignsGroupsSuccess(results));

            return { results };
        } catch (error) {
            dispatch(addIndication(generateErrorIndication(error)));

            return { error };
        }
    };

export default bulkUpdateCampaignsGroups;
